module.exports = __webpack_public_path__ + "static/layer1-1226b9bd08bbf1ce9a0552e40981bc57.png";